// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__fUwnT","author":"Table_author__3uEiF","authorImage":"Table_authorImage__m5Fnr","unreadRow":"Table_unreadRow__1JICy"};